// extracted by mini-css-extract-plugin
export var gif = "_m7-0";